import {useMemo} from 'react';
import {useStudentDetailService} from '../../../../hooks';
import {useBehaviorSubject} from '@esgi/ui';
import {Tests} from '../tests';
import {AlertBody as Body, ReportWrapper, Page, Student} from './index.styled';
import {groupTestByTwo} from '../../utils';
import {Text} from '@esgi/ui/typography';

export function AlertBody() {
	const service = useStudentDetailService();
	const report = useBehaviorSubject(service.report$);
	const printSettings = useBehaviorSubject(service.printSettings$);

	const testList = useMemo(() => report.students.map((student) => (
		<Page key={student.studentID}>
			<Student>
				<Text>{`${student.firstName || ''} ${student.lastName || ''}`}</Text>
			</Student>
			{groupTestByTwo(student.tests).map((tests, index) => (
				<Tests
					key={`${student.studentID}-${index}`}
					tests={tests}
					report={report}
					printSettings={printSettings}
				/>
			))}
		</Page>
	)), [report, printSettings]);

	return (
		<Body>
			<ReportWrapper>
				{testList}
			</ReportWrapper>
		</Body>
	);
}
